// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (
workingHourContractPrice) => (
{
  ...workingHourContractPrice,
  price: convertFromRubToKop(workingHourContractPrice.price)
});

const convertDataFromServer = (
workingHourContractPrice) => (
{
  ...workingHourContractPrice,
  price: convertFromKopToRub(workingHourContractPrice.price)
});

const workingHourContractPrice = new CommonApi(
  'workingHourContractPrice',
  'Стоимость нормо-часа подрядным способом',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...workingHourContractPrice
};
